import { makeStyles, tokens } from '@fluentui/react-components';

export const useContractNegotiationListStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalL,
    width: '100%',
    minWidth: 0,
    overflow: 'hidden',
  },
  toolbar: {
    display: 'flex',
    gap: tokens.spacingHorizontalM,
    justifyContent: 'space-between',
    alignItems: 'center',
    flexWrap: 'wrap',
  },
  gridWrapper: {
    border: `1px solid ${tokens.colorNeutralStroke1}`,
    borderRadius: tokens.borderRadiusMedium,
    overflowX: 'auto',
    overflowY: 'hidden',
    width: '100%',
    minWidth: 0,
  },
  emptyState: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: tokens.spacingVerticalXXL,
    gap: tokens.spacingVerticalM,
    color: tokens.colorNeutralForeground3,
  },
  actionCell: {
    display: 'flex',
    gap: tokens.spacingHorizontalXS,
    alignItems: 'center',
    flexWrap: 'wrap',
  },
  statusBadge: {
    minWidth: '80px',
  },
  fullRow: {
    gridColumn: '1 / -1',
  },
  selectedRow: {
    backgroundColor: tokens.colorBrandBackground2,
    ':hover': {
      backgroundColor: tokens.colorBrandBackground2Hover,
    },
  },
  clickableRow: {
    cursor: 'pointer',
  },
});
